import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { toFixedWithoutRounding } from "../Utils/constants";

const icon = (name) => `/static/image/profile/${name}`;

const FUNDS_ITEMS = [
  { labelKey: "Deposit", icon: icon("icon-deposit.svg"), href: "/deposit" },
  {
    labelKey: "Withdrawal",
    icon: icon("icon-withdrawal.svg"),
    href: "/withdraw",
  },
];

const HISTORY_ITEMS = [
  {
    labelKey: "BettingRecords",
    icon: icon("icon-total.svg"),
    href: "/history/betting",
  },
  {
    labelKey: "Turnover",
    icon: icon("icon-total.svg"),
    href: "/history/turnover",
  },
  {
    labelKey: "AccountStatement",
    icon: icon("icon-tranfer.svg"),
    href: "/history/account-statement",
  },
  {
    labelKey: "SpinReport",
    icon: icon("icon-bonus.svg"),
    href: "/history/spin-report",
  },
  // { label: "Bonus", icon: icon("icon-bonus.svg"), href: "/history/bonus" },
  {
    labelKey: "TransactionRecords",
    icon: icon("icon-transaction.svg"),
    href: "/history/transaction",
  },
];

// const EVENT_ITEMS = [
//   {
//     label: "Claim Voucher",
//     icon: icon("icon-grabcoin.svg"),
//     href: "/event/voucher",
//     width: "150px",
//   },
//   {
//     label: "Rewards",
//     icon: icon("icon-checkin.svg"),
//     href: "/event/checkin",
//     width: "150px",
//   },
// ];

const PROFILE_ITEMS = [
  {
    labelKey: "PersonalInfo",
    icon: icon("icon-info.svg"),
    href: "/profile/personal-info",
  },
  {
    labelKey: "Change_Password",
    icon: icon("icon-reset.svg"),
    href: "/profile/change-password",
  },
  // {
  //   label: "Bank Details",
  //   icon: icon("icon-info.svg"),
  //   href: "/profile/bank-details",
  // },
  // {
  //   label: "Inbox Messages",
  //   icon: icon("icon-inbox.svg"),
  //   href: "/profile/inbox",
  // },
  {
    labelKey: "Referral",
    icon: icon("icon-referral.svg"),
    href: "/referral",
  },
  {
    labelKey: "Affiliate",
    icon: icon("icon-referral.svg"),
    href: "/affiliate-link",
  },
];

const CONTACT_ITEMS = [
  // {
  //   label: "24/7 Support",
  //   icon: icon("icon-support.svg"),
  //   href: "#",
  //   external: true,
  // },
  {
    labelKey: "WhatsApp",
    icon: icon("icon-whatsapp.svg"),
    href: "https://wa.me/",
    external: true,
  },
  {
    labelKey: "Telegram",
    icon: icon("icon-telegram.svg"),
    href: "https://t.me",
    external: true,
    width: "150px",
  },
  {
    labelKey: "Facebook",
    icon: icon("icon-fb.svg"),
    href: "https://facebook.com",
    external: true,
  },
];

const Profile = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const amounutRefresh = useContextSelector(
    AuthContext,
    (ctx) => ctx.amounutRefresh,
  );
  const refreshAmountLoader = useContextSelector(
    AuthContext,
    (ctx) => ctx.refreshAmountLoader,
  );
  const userCoins = useContextSelector(AuthContext, (ctx) => ctx.userCoins);

  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);
  const [balance, setBalance] = useState(null);
  const [balanceHidden, setBalanceHidden] = useState(true);
  const handleLogout = () => {
    logoutUser();
  };

  const goTo = (item) => {
    onClose?.();
    if (item.external) {
      window.open(item.href, "_blank", "noopener,noreferrer");
    } else {
      navigate(item.href);
    }
  };
  const initial = user?.user?.username?.charAt(0)?.toUpperCase() || "A";
  const displayName = user?.user?.username || "Guest";

  const renderRow = (items) => (
    <div className="profile-sheet-item-row-mobile">
      {items.map((item) => (
        <div
          key={item.labelKey}
          className="profile-sheet-item-column"
          onClick={() => goTo(item)}
          style={{ cursor: "pointer" }}
        >
          <div className="profile-sheet-icon">
            <div className="v-image v-responsive theme--light">
              <div
                className="v-responsive__sizer"
                style={{ paddingBottom: "100%" }}
              />
              <div
                className="v-image__image v-image__image--cover"
                style={{
                  backgroundImage: `url("${item.icon}")`,
                  backgroundPosition: "center center",
                }}
              />
              <div
                className="v-responsive__content"
                style={{ width: item.width || "36px" }}
              />
            </div>
          </div>
          <label>{t(item.labelKey)}</label>
        </div>
      ))}
    </div>
  );

  return (
    <div
      role="document"
      tabIndex={0}
      className="v-dialog__content v-dialog__content--active"
      style={{ zIndex: 202 }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent v-dialog--fullscreen v-dialog--scrollable v-bottom-sheet"
        style={{ transformOrigin: "center center" }}
      >
        <div className="profile-sheet v-sheet theme--light">
          <div className="profile-sheet-wrapper">
            <div className="profile-sheet-header">
              <div className="profile-sheet-header-wrapper">
                <div className="profile-sheet-close-wrapper" onClick={onClose}>
                  <i
                    aria-hidden="true"
                    className="v-icon notranslate profile-sheet-close-icon white--text material-icons theme--light"
                  >
                    clear
                  </i>
                </div>
                <div className="header-member-name">
                  <div
                    className="v-avatar profile-sheet-profile-avatar"
                    style={{ height: "84px", minWidth: "84px", width: "84px" }}
                  >
                    <div>{initial}</div>
                  </div>
                  <div>{displayName}</div>
                </div>
              </div>
            </div>

            <div className="profile-sheet-body">
              <div className="profile-sheet-body-wrapper">
                {/* ---- Wallet ---- */}
                <div className="profile-sheet-item profile-sheet-wallet">
                  <div className="profile-sheet-balance">
                    <label>{t("MainWallet")}</label>
                    <div
                      className={
                        "refresh-balance-icon" +
                        (refreshAmountLoader ? " spinning" : "")
                      }
                      onClick={amounutRefresh}
                      style={{ cursor: "pointer" }}
                    />
                    <div
                      onClick={() => setBalanceHidden((v) => !v)}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        aria-hidden="true"
                        className={
                          "v-icon notranslate mdi theme--light " +
                          (balanceHidden
                            ? "mdi-eye-off mask-balance"
                            : "mdi-eye")
                        }
                      />
                    </div>
                  </div>
                  <div>
                    {refreshAmountLoader ? (
                      <div
                        role="progressbar"
                        aria-valuemin={0}
                        aria-valuemax={100}
                        className="v-progress-circular v-progress-circular--visible v-progress-circular--indeterminate amber--text"
                        style={{ height: "24px", width: "24px" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715"
                          style={{
                            "-webkit-transform": "rotate(0deg)",
                            "-ms-transform": "rotate(0deg)",
                            transform: "rotate(0deg)",
                          }}
                        >
                          <circle
                            fill="transparent"
                            cx="45.714285714285715"
                            cy="45.714285714285715"
                            r={20}
                            strokeWidth="5.714285714285714"
                            strokeDasharray="125.664"
                            strokeDashoffset="125.66370614359172px"
                            className="v-progress-circular__overlay"
                          />
                        </svg>
                        <div className="v-progress-circular__info" />
                      </div>
                    ) : (
                      <label className="text-capitalize balance">
                        <span>
                          ৳{" "}
                          {balanceHidden
                            ? "*.**"
                            : toFixedWithoutRounding(userCoins?.totalCoins) ||
                              "0.00"}
                        </span>
                      </label>
                    )}
                  </div>
                </div>

                {/* ---- Funds ---- */}
                <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">{t("Funds")}</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  {renderRow(FUNDS_ITEMS)}
                </div>

                {/* ---- History ---- */}
                <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">{t("History")}</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  {renderRow(HISTORY_ITEMS)}
                </div>

                {/* <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">Event</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  {renderRow(EVENT_ITEMS)}
                </div> */}

                {/* ---- Profile ---- */}
                <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">{t("Profile")}</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  {renderRow(PROFILE_ITEMS)}
                </div>

                {/* ---- Contact Us ---- */}
                <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">{t("CONTACTUS")}</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  {renderRow(CONTACT_ITEMS)}
                </div>

                {/* ---- Download ---- */}
                {/* <div className="profile-sheet-item">
                  <div className="profile-sheet-item-header">
                    <div className="profile-sheet-item-title">Download</div>
                  </div>
                  <div className="profile-sheet-item-divider" />
                  <div className="profile-sheet-item-row-mobile">
                    <div
                      className="profile-sheet-item-column"
                      onClick={() =>
                        window.open("/winx9_2024_new.apk", "_blank")
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div className="profile-sheet-icon">
                        <div className="v-image v-responsive theme--light">
                          <div
                            className="v-responsive__sizer"
                            style={{ paddingBottom: "100%" }}
                          />
                          <div
                            className="v-image__image v-image__image--cover"
                            style={{
                              backgroundImage: `url("${icon("icon-downloadapk.png")}")`,
                              backgroundPosition: "center center",
                            }}
                          />
                          <div
                            className="v-responsive__content"
                            style={{ width: "150px" }}
                          />
                        </div>
                      </div>
                      <label>Download Android</label>
                    </div>
                  </div>
                </div> */}

                {/* ---- Logout ---- */}
                <div
                  className="logout-container"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >
                  <div className="logout-btn">
                    <div className="logout-icon" />
                    <div>{t("LogOut")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
